import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'service-types',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `service-types`,
    method: 'get',
    params: queriesParams
  })
}

export function show (id) {
  return request({
    url: `service-type/${id}`,
    method: 'get'
  })
}

export function add (data) {
  return request({
    url: 'service-type',
    method: 'post',
    data
  })
}

export function edit (id, data) {
  return request({
    url: `service-type/${id}`,
    method: 'patch',
    data
  })
}